(function () {
  // Fetch cart
  document.addEventListener("DOMContentLoaded", function () {
    fetchCart();
  });
  /**
   * =================================================================
   *  Library functions
   * =================================================================
   */
  function insertContent(selector, content) {
    if (typeof document.body == "object") {
      selector.innerHTML = content;
    } else {
      var element = document.querySelector(selector);
      if (element) {
        element.innerHTML = content;
      }
    }
  }

  // Live click event
  function live(selector, event, callback, context) {
    // helper for enabling IE 8 event bindings
    function addEvent(el, type, handler) {
      if (el.attachEvent) el.attachEvent("on" + type, handler);
      else el.addEventListener(type, handler);
    }
    // matches polyfill
    this.Element &&
      (function (ElementPrototype) {
        ElementPrototype.matches =
          ElementPrototype.matches ||
          ElementPrototype.matchesSelector ||
          ElementPrototype.webkitMatchesSelector ||
          ElementPrototype.msMatchesSelector ||
          function (selector) {
            var node = this,
              nodes = (node.parentNode || node.document).querySelectorAll(selector),
              i = -1;
            while (nodes[++i] && nodes[i] != node);
            return !!nodes[i];
          };
      })(Element.prototype);
    // live binding helper using matchesSelector
    function live(selector, event, callback, context) {
      addEvent(context || document, event, function (e) {
        var found,
          el = e.target || e.srcElement;
        while (el && el.matches && el !== context && !(found = el.matches(selector)))
          el = el.parentElement;
        if (found) callback.call(el, e);
      });
    }
    live(selector, event, callback, context);
  }

  // Defaults selector
  var defaults = {
    cartModal: ".js-ajax-cart-modal",
    cartModalContent: ".js-ajax-cart-modal-content",
    cartModalClose: ".js-ajax-cart-modal-close",
    cartDrawer: ".js-ajax-cart-drawer",
    cartDrawerContent: ".js-ajax-cart-drawer-content",
    cartDrawerClose: ".js-ajax-cart-drawer-close",
    cartDrawerTrigger: ".js-ajax-cart-drawer-trigger",
    cartOverlay: ".js-ajax-cart-overlay",
    cartCounter: ".js-ajax-cart-counter",
    cartCounterMobile: ".js-ajax-cart-counter-mobile",
    addToCart: ".js-ajax-add-to-cart",
  };

  // Cart Elements
  let cartModal = document.querySelector(defaults.cartModal);
  let cartModalContent = document.querySelector(defaults.cartModalContent);
  let cartModalClose = document.querySelector(defaults.cartModalClose);
  let cartDrawer = document.querySelector(defaults.cartDrawer);
  let cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
  let cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
  let cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
  let cartOverlay = document.querySelector(defaults.cartOverlay);
  let cartCounter = document.querySelector(defaults.cartCounter);
  let cartCounterMobile = document.querySelector(defaults.cartCounterMobile);
  let addToCart = document.querySelectorAll(defaults.addToCart);

  let htmlSelector = document.documentElement;

  /**
   * =================================================================
   *  Cart Object
   * =================================================================
   */
  var MainCart = {
    // ------- Cart Drawer -------
    openCartDrawer() {
      cartDrawer.classList.add("is-open");
    },

    closeCartDrawer() {
      cartDrawer.classList.remove("is-open");
    },

    clearCartDrawer() {
      cartDrawerContent.innerHTML = "";
    },

    // ------- Cart Modal -------
    openAddModal() {
      cartModal.classList.add("is-open");
    },

    closeAddModal() {
      cartModal.classList.remove("is-open");
    },

    // ------- Cart Overlay -------
    openCartOverlay() {
      cartOverlay.classList.add("is-open");
      htmlSelector.classList.add("is-locked");
    },

    closeCartOverlay() {
      cartOverlay.classList.remove("is-open");
      htmlSelector.classList.remove("is-locked");
    },

    // ------- Update Cart Quantity -------
    updateCartQuantity(lineItemIndex, quantity, lineItemId) {
      console.log(quantity, lineItemIndex);
      //return true;
      $.ajax({
        type: "POST",
        url: "https://shop-confete.com/cart/change.js", // Replace with your actual URL to update the cart
        data: {
          line: lineItemIndex,
          quantity: quantity,
        },
        success: function (response) {
          const responseData = JSON.parse(response);
          console.log(JSON.parse(response), "response");
          cartCounter.innerHTML = responseData.item_count;
          cartCounterMobile.innerHTML = responseData.item_count;
          fetchCart(); // Refresh the cart
        },
        error: function (error) {
          // ToDo if error revert last updat either hit minus or plus
          let quantityElement = document.querySelector(
            `.quantity-value[data-line-item-id="${lineItemId}"]`
          );

          if (quantityElement) {
            quantityElement.innerHTML = quantity - 1;
          }

          addToCartFail();
        },
      });
    },

    increaseQuantity(lineItemId) {
      var quantityElement = document.querySelector(
        `.quantity-value[data-line-item-id="${lineItemId}"]`
      );
      var lineItemIndex = quantityElement.dataset.lineIndex;
      var quantity = parseInt(quantityElement.innerText);
      quantityElement.innerText = ++quantity;
      MainCart.updateCartQuantity(lineItemIndex, quantity, lineItemId);
    },

    decreaseQuantity(lineItemId) {
      var quantityElement = document.querySelector(
        `.quantity-value[data-line-item-id="${lineItemId}"]`
      );
      var quantity = parseInt(quantityElement.innerText);
      var lineItemIndex = quantityElement.dataset.lineIndex;
      quantityElement.innerText = --quantity;
      MainCart.updateCartQuantity(lineItemIndex, quantity, lineItemId);
    },
  };

  /**
   * =================================================================
   *  Cart drawer
   * =================================================================
   */
  // Click on add to cart button
  live(defaults.addToCart, "click", function (event) {
    event.preventDefault();
    var form = this.closest("[data-product-form]");
    let form_id = form?.getAttribute("id");

    // Add product to cart
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: $("#" + form_id).serialize(),
      success: function () {
        addToCartOk(this, form);
      },
      error: addToCartFail,
    });
  });

  // Click Events
  cartModalClose.addEventListener("click", function () {
    MainCart.closeAddModal();
    MainCart.closeCartOverlay();
  });

  cartDrawerClose.addEventListener("click", function () {
    MainCart.closeCartDrawer();
    MainCart.closeCartOverlay();
  });

  // dodati overflow na body di treba, cart is empty stanje
  cartOverlay.addEventListener("click", function () {
    MainCart.closeAddModal();
    MainCart.closeCartDrawer();
    MainCart.closeCartOverlay();
  });

  cartDrawerTrigger.addEventListener("click", function (event) {
    event.preventDefault();
    fetchCart();
    MainCart.openCartDrawer();
    MainCart.openCartOverlay();
  });

  /**
   * Ajax cart
   */

  // Response once product added to cart
  function addToCartOk(product, form) {
    if (cartModalContent) {
      cartModalContent.innerHTML = product.title + " was added to the cart!";
    }

    var val = form.querySelector("input#quantity").value;

    if (val != "" && typeof val != "undefined" && val != null) {
      insertContent(cartCounter, Number(cartCounter.innerHTML) + Number(val));
      insertContent(cartCounterMobile, Number(cartCounterMobile.innerHTML) + Number(val));
    } else {
      insertContent(cartCounter, Number(cartCounter.innerHTML) + 1);
      insertContent(cartCounterMobile, Number(cartCounterMobile.innerHTML) + 1);
    }

    // Open cart drawer
    MainCart.openCartDrawer();
    MainCart.openCartOverlay();

    // Fetch cart information
    fetchCart();
  }

  // Fetch cart information
  function fetchCart(callback) {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (typeof callback === "function") {
          callback(cart);
        } else {
          renderCart(cart);
        }
      });
  }

  function addToCartFail() {
    cartModalContent.innerHTML = "The product you are trying to add is out of stock.";
    MainCart.openAddModal();
    MainCart.openCartOverlay();
  }

  function renderCart(cart) {
    MainCart.clearCartDrawer();
    var lineIndex = 1;

    console.log("Render function cart Items => ", cart);
    document.querySelector('.drawer__title #item-count').innerText = cart.item_count;
    cart.items.forEach(function (item) {
      
      console.log(item, "item");
      let productQuantity = `
        <div class="ajax-cart-item__quantity">
         <button class="quantity-increase" data-line-index="${lineIndex}" data-line-item-id="${item.id}">
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" fill="#FAECE7"/>
            <path d="M7.5 12H16.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 16.5V7.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
           </svg>
         </button>
          <span class="quantity-value" data-line-index="${lineIndex}" data-line-item-id="${item.id}">${item.quantity}</span>
          <button class="quantity-decrease" data-line-index="${lineIndex}" data-line-item-id="${item.id}">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" fill="#FAECE7"/>
            <path d="M7.5 12H16.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          </button>
        </div>`;

      // Product title
      let productTitle =
        '<div class="ajax-cart-item__title"><a class="" href="' +
        item.url +
        '">' +
        item.product_title +
        "</a></div>";

      let productImage =
        '<div class="product-img"><img class="ajax-cart-item__image" src="' +
        item.image +
        '" ></div>';

      let productPrice =
        '<div class="ajax-cart-item__price">$' + (item.line_price / 100).toFixed(2) + "</div>";

      let removeItem =
        '<div class="ajax-cart-item__remove"><button data-line-index="' +
        lineIndex +
        '">remove</button></div>';

      let deliveryDateKey = "";
      let deliveryDateValue = "";

      // Keys
      for (let key in item.properties) {
        if (item.properties.hasOwnProperty(key)) {
          let value = item.properties[key];
          deliveryDateKey = `${key}`;
          deliveryDateValue = ` ${value}`;
          console.log(`Key: ${key}, Value: ${value}`);
        }
      }

      let productDeliveryDate =
        '<div class="ajax-cart-item__delivery">' + deliveryDateKey + deliveryDateValue + "</div>";

      let concatProductInfo = 
        '<div class="single-item">' +
        productImage +
        '<div class="item-info">' +
        productTitle +
        '<div class="product-selected-variant"><div class="current_variant">'+ item.variant_options +'</div> <div class="product_item__price">'+ productPrice +'</div></div>'+
        '<div class="quantityBox_wrapper">' +
        productQuantity +
        removeItem +
        productPrice +
        "</div>" +
        productDeliveryDate +
        "</div>";

      cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

      lineIndex++;
    });
    $(".cart-totals .total-value").text("$" + (cart.total_price / 100).toFixed(2));

    // Add event listeners for new buttons
    document.querySelectorAll(".quantity-increase").forEach((button) => {
      button.addEventListener("click", () => MainCart.increaseQuantity(button.dataset.lineItemId));
    });

    document.querySelectorAll(".quantity-decrease").forEach((button) => {
      button.addEventListener("click", () => MainCart.decreaseQuantity(button.dataset.lineItemId));
    });

    document.querySelectorAll(".ajax-cart-item__remove button").forEach((button) => {
      console.log(button.dataset.lineIndex);
      button.addEventListener("click", function () {
        console.log(this.dataset.lineIndex);
        MainCart.updateCartQuantity(button.dataset.lineIndex, 0);
      });
    });

    updateCart();
  }

  // UPdate cart
  function updateCart() {
    $.ajax({
      type: "GET",
      url: "/cart.js", // Shopify's AJAX API endpoint
      dataType: "json",
      success: function (cart) {
        var total = cart.total_price / 100; // Convert Shopify's total to dollars
        var threshold = 150;

        var remainingAmount = threshold - total;
        var progressBar = document.getElementById("progressBar");
        var message = document.getElementById("message");
        var cartTotal = document.getElementById("cartTotal");

        if (total < threshold) {
          var percentage = (total / threshold) * 100;
          message.textContent = `Add $${remainingAmount.toFixed(
            2
          )} to your bag to get free shipping!`;
          progressBar.style.width = `${percentage}%`;
        } else {
          message.textContent = "Hooray! You’re getting free shipping!";
          progressBar.style.width = "100%";
        }

        // cartTotal.textContent = `Total: $${total.toFixed(2)}`;
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        console.error("Error fetching cart data:", errorThrown);
      },
    });
  }

  // Call updateCart initially to load the initial cart data
  updateCart();

  /**
   *
   * Copy to clipboard
   *
   * This class handler the copy clipboard functionality
   *
   */
  class CopyToClipboard extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        copybtn: ".mm__copy-btn-main",
        copyElm: "mm__promo-copy-message",
      };

      this.init();
    }

    // Clipboard initialize
    init() {
      this.dispatchEvents();
    }


    // Function to copy text to clipboard
    copyToClipboard(text) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    }

    // Function to display message
    showMessage(message) {
      var copyMessage = document.querySelector(this.selectors.copyElm);
      if (copyMessage) {
        copyMessage.style.display = "block";
        copyMessage.textContent = message;
        setTimeout(function () {
          copyMessage.style.display = "none";
        }, 5000);
      }
    }

   dispatchEvents() {
      var copyBtn = this.querySelector(this.selectors.copybtn);
      var _this = this;
      if (copyBtn) {
        copyBtn.addEventListener("dblclick", function (e) {
          e.preventDefault();
          _this.copyToClipboard.bind(this)("CONFETE10");
          _this.showMessage.bind(this)("Text Copied!");
        });

        copyBtn.addEventListener("click", function (e) {
          e.preventDefault();
          _this.copyToClipboard.bind(this)("CONFETE10");
          _this.showMessage.bind(this)("Text Copied!");
        });
      }
    }

  }
  customElements.define("copy-to-clipboard", CopyToClipboard);
})();
 